import { 
  signInWithPopup, 
  signOut 
} from "firebase/auth";
import { auth, googleProvider } from "../firebaseConfigurations/config";

export const loginWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    return result.user;
  } catch (error) {
    console.error("Google login failed:", error);
    throw new Error(error.message || "Google login failed.");
  }
};

export const logout = async () => {
  try {
    await signOut(auth);
  } catch (error) {
    console.error("Logout failed:", error);
    throw new Error(error.message || "Logout failed.");
  }
};
